// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

//localhost
export const environment = {
  production: true,
  identityServer: 'http://localhost:8010/proxy',
  apiServer: 'http://localhost:8011/proxy',
  authHeaderClient: 'Basic dGFrb21hY2xpZW50OnNlY3JldA=='
};

//dev
// export const environment = {
//   production: true,
//   identityServer: 'http://78.24.180.135:6464/identity',
//   apiServer: 'http://78.24.180.135:6464/api',
//   authHeaderClient: 'Basic dGFrb21hY2xpZW50OnNlY3JldA=='
// };




// WEBPACK FOOTER //
// ./src/environments/environment.ts